var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.464844 3.83984C0.601562 3.97656 0.806641 3.96289 0.943359 3.83984L2.51562 2.18555V6.10938C2.51562 6.30078 2.65234 6.4375 2.84375 6.4375H3.28125C3.45898 6.4375 3.60938 6.30078 3.60938 6.10938V2.18555L5.16797 3.82617C5.30469 3.96289 5.50977 3.96289 5.64648 3.83984L5.94727 3.53906C6.07031 3.40234 6.07031 3.19727 5.94727 3.07422L3.28125 0.408203C3.1582 0.285156 2.95312 0.285156 2.83008 0.408203L0.164062 3.07422C0.0410156 3.19727 0.0410156 3.40234 0.164062 3.53906L0.464844 3.83984Z",
    fill: "#08A918"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/upArrow.21e4f9d349abe13d59ec13794630dbe1.svg";
export { ForwardRef as ReactComponent };